import React, { createContext, useState, useRef, useEffect, useContext } from 'react';


const Context_ERUMAUI = createContext();

export function Provider_ERUMAUI({ children }) {
    const Animation_Pulse = (Target, Animation = "Active") => {
        if (!Target) { return; }
        Target.setAttribute("Animation_Pulse", Animation);
        const Handle_End = () => {
            Target.removeAttribute("Animation_Pulse");
            Target.removeEventListener("animationend", Handle_End);
        }
        Target.addEventListener("animationend", Handle_End, { once: true });
    }
    const Animation_Sequence = (Targets = []) => {
        Targets.forEach(({ Type, Class, Wait, ID, Animation, Stick = false, Delay = 0, Delay_Stagger = 0 }) => {
            if (Type === "ID") {
                const Target = document.getElementById(ID);
                if (!Target) return;
                Target.setAttribute("Animation", "None");

                setTimeout(() => {
                    Target.setAttribute("Animation", Animation);
                    const handleEnd = () => {
                        Target.removeEventListener("animationend", handleEnd);
                        if (!Stick) {
                            Target.setAttribute("Animation", "None");
                        }

                    };
                    Target.addEventListener("animationend", handleEnd, { once: true });
                }, Delay);
            }
            if (Type === "Class") {
                Animation_Stagger("Class", Class, Animation, Delay_Stagger);
            }
        });
    };

    const Animation_Sequence_Test = async (Targets = []) => {
        let Cursor_Timeline = 0; // Tracks the "current time" in the sequence

        for (const step of Targets) {
            const { Type, ID, Class, Animation, Delay = 0, Stick, Wait } = step;

            // Compute this step's start time relative to previous step
            const Time_Start = Cursor_Timeline + Delay;

            // Wait until it's time to start this step
            await new Promise((resolve) => setTimeout(resolve, Time_Start - Cursor_Timeline));

            // Start the animation
            const Animation_Play = () => {
                return new Promise((resolve) => {
                    let targets = [];

                    if (Type === "ID" && ID) {
                        const el = document.getElementById(ID);
                        if (el) targets = [el];
                    }
                    else if (Type === "Class" && Class) {
                        targets = [...document.querySelectorAll(Class)];
                    }

                    targets.forEach((target, index) => {
                        // Reset previous state to allow re-trigger
                        target.setAttribute("Animation", "None");

                        // For class-type, you might want to stagger within the group
                        const staggerDelay = Type === "Class" ? Delay * index : 0;

                        setTimeout(() => {
                            target.setAttribute("Animation", Animation);

                            const handleEnd = () => {
                                target.removeEventListener("animationend", handleEnd);
                                if (!Stick) {
                                    target.setAttribute("Animation", "None");
                                }
                                resolve(); // resolve on first element's end if Wait is true
                            };

                            if (Wait) {
                                // Resolve when the first target ends
                                target.addEventListener("animationend", handleEnd, { once: true });
                            } else {
                                // If not waiting, resolve immediately (doesn't block timeline)
                                if (index === 0) resolve();
                            }
                        }, staggerDelay);
                    });

                    // If no targets found, just resolve immediately
                    if (targets.length === 0) resolve();
                });
            };

            await Animation_Play();

            // Move timeline cursor forward
            Cursor_Timeline = Time_Start;
        }
    };


    const Animation_Stagger = (Type, Class, Animation, Delay) => {
        if (Type === "Class") {
            const Targets = document.querySelectorAll(Class);
            Targets.forEach((Target, Index) => {
                Target.setAttribute("Animation", "None");
                setTimeout(() => {
                    Target.setAttribute("Animation", Animation);
                    const handleEnd = () => {
                        Target.removeEventListener("animationend", handleEnd);
                    };
                    Target.addEventListener("animationend", handleEnd, { once: true });
                }, (Delay * Index));
            });
        }
    }

    const [Toasts, Toasts_Set] = useState([]);
    const Toast_Add = (Data) => {
        const ID = `UI_Toast_${Date.now()}`;

        const New_Toast = {
            ID: ID,
            State: "Active",
            ...Data
        };

        Toasts_Set(Previous => [...Previous, New_Toast]);
        return ID;
    }

    const Toast_Remove = (ID) => {
        Toasts_Set(Previous => Previous.map(Toast => {
            if (Toast.ID === ID) {
                return { ...Toast, State: "Inactive" };
            }
            return Toast;
        }));
    }

    const Toast_Delete = (ID) => {
        Toasts_Set(Previous => Previous.filter(Toast => Toast.ID !== ID));
    }

    const Toast_Update = (ID, Data) => {
        Toasts_Set(Previous => Previous.map(Toast => {
            if (Toast.ID === ID) {
                return { ...Toast, ...Data }
            }
            return Toast;
        }))
    }

    const [Overlays_Active, Overlays_Active_Set] = useState([]);
    const [Overlay_Current, Overlay_Current_Set] = useState(null);

    const Overlay_Open = (ID, Delay = 200) => {
        if (Overlays_Active.find(o => o.ID === ID)) return;

        const Payload = {
            ID: ID,
            State: "Active"
            // Delete_Delay: Delay
        };
        Overlays_Active_Set(prev => [...prev, Payload]);
        Overlay_Current_Set(ID);
    }

    const Overlay_Close = (ID) => {
        Overlays_Active_Set(Previous => Previous.map(Overlay => {
            if (Overlay.ID === ID) {
                return { ...Overlay, State: "Inactive" };
            }
            return Overlay;
        }));
    }

    const Overlay_Delete = (ID) => {
        Overlays_Active_Set(Previous => Previous.filter(Overlay => Overlay.ID !== ID));
    }

    const [LoadingScreen_Active, LoadingScreen_Active_Set] = useState(false);
    return (
        <Context_ERUMAUI.Provider value={{
            Animation_Pulse,
            Animation_Sequence,
            Animation_Stagger,
            Toast_Add,
            Toast_Remove,
            Toast_Delete,
            Toast_Update,
            Toasts,
            Overlays_Active,
            Overlays_Active_Set,
            Overlay_Open,
            Overlay_Close,
            Overlay_Delete,
            Overlay_Current,
            Overlay_Current_Set,
            LoadingScreen_Active,
            LoadingScreen_Active_Set
        }}>
            {children}
        </Context_ERUMAUI.Provider>
    );
}

export function useERUMAUI() {
    return useContext(Context_ERUMAUI);
}